import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetInvoiceLineItemsResponse } from "./getInvoiceLineItemsRequest.schema";

/**
 * @description
 * Fetches all contractor payments and employee shifts to be included in an invoice for a list of customer account IDs
 * based on those customers' invoice templates.
 *
 * Sends GET request to la-forge route:
 * GET /api/invoices/line-items?customerAccountIDs={customerAccountIDs}
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param customerAccountIDs - list of customer account IDs to fetch contractor payments and employee shifts for
 * @returns list of contractor payments and employee shifts to be included in an invoice for the given customer account IDs
 */
export const getInvoiceLineItems =
  (axios: IAxiosInstance) =>
  async (
    customerAccountIDs: string[]
  ): Promise<TGetInvoiceLineItemsResponse> => {
    const response = await axios.noRetry.get("/api/invoices/line-items", {
      params: { customerAccountIDs },
    });

    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error fetching invoice line items");
  };
